export default "__VITE_ASSET__Chwr6QPL__"